import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { required as requiredValidation } from '../validation';
import { StyledSelect } from './dict-filter.styled';

export const SelectFilter = (props) => {
  const { t } = useTranslation();
  const { theme = '', withEmpty = true, emptyName = t('filter.Все'), required = false, title = '', items, name, w, ...rest } = props;

  const requiredT = useCallback(requiredValidation(t), [t]);
  if (required) {
    rest.validate = requiredT;
  }

  // get items el
  const getItemsEl = () => {
    return items.map((el, idx) => {
      let val = el.value;
      return (
        <option key={idx} value={val}>
          {el.name}
        </option>
      );
    });
  };

  const optionsEl = getItemsEl();

  return (
    <StyledSelect type="select" width={w} name={name} label={title} theme={theme} {...rest}>
      {withEmpty && <option value="">{emptyName}</option>}
      {optionsEl}
    </StyledSelect>
  );
};

SelectFilter.propTypes = {
  items: PropTypes.any.isRequired, //string.isRequired | PropTypes.array.isRequired,
  name: PropTypes.string,
  title: PropTypes.string,
  theme: PropTypes.string,
};
